export { TherapistsPopularTopics } from "./TherapistsPopularTopics"
